import styled from 'styled-components';
const percentageSize = 1.3;

export const Background = styled.div`
  position: ${({ active }) => (active ? 'fixed' : 'none')};
  z-index: 15;
  width: 100%;
  height: 100%;
  background-color: rgba(51, 51, 51, 0.6);
`;

export const ModalContainer = styled.div`
  position: fixed;
  display: ${({ modalOpen }) => (modalOpen ? 'flex' : 'none')};
  flex-direction: column;
  background-color: #333c;
  border-radius: 10px;
  z-index: 15;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: ${({ info }) => (info ? '580px' : '550px')};

  @media screen and (max-width: 768px) {
    transform: translateY(0%);
    width: auto;
    border-radius: 0;
    bottom: 0;
    height: fit-content;
    top: auto;
  }
`;

export const OptionsWrapper = styled.div`
  display: flex;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
  flex-direction: column;
  padding: ${({ info, download }) => (info ? '0 10px 25px 25px' : download ? '10px 15px 25px 15px' : '25px 15px')};
`;

export const OptionWrapper = styled.div`
  display: flex;
  color: white;
  align-items: center;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
  padding-bottom: 5px;
  cursor: pointer;
`;

export const TextWrapper = styled.div`
  display: inline-flex;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
  color: white;
  gap: 15px;
  align-items: center;
  padding-bottom: 5px;
`;
export const CompartirTitle = styled.div`
  color: white;
  margin-bottom: 10px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
  font-weight: bold;
`;
export const OptionTitle = styled.div`
  color: white;
  cursor: pointer;
  padding-left: 15px;
  display: flex;
  align-items: center;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;

  :hover {
    color: #febf00;
  }
`;

export const ShareOptionsWrapper = styled.div`
  padding-left: 10px;
`;

export const LinkWrapper = styled.a`
  display: inline-flex;
  align-items: center;
  text-decoration: none;
`;

export const SeparatorRow = styled.div`
  content: '';
  background-color: rgb(183, 183, 183);
  width: 100%;
  height: 1px;
  margin-bottom: 10px;
  margin-top: 10px;
  margin-right: 50px;
  opacity: 0.8;
`;

export const ShareBar = styled.nav`
  background-color: #333;
  /* box-shadow: 0 4px 7px -2px #252525; */
  display: flex;
  align-items: center;
  z-index: 3;
  height: 30px;
  border-radius: 10px 10px 0px 00px;

  @media screen and (max-width: 768px) {
    border-radius: 0;
  }
`;

export const ShareBarWrapper = styled.div`
  display: flex;
  justify-content: center;
  height: 6px;
  align-items: center;
`;

export const BarTitleWrappper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  height: 15px;
`;

export const CloseBtnWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  width: 25px;
  position: absolute;
  right: 1%;
`;

export const BarBtn = styled.button`
  background-color: transparent;
  border: 0px;
  margin: 0px;
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BarTitle = styled.span`
  color: white;
  padding-left: 15px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;

  @media screen and (max-width: 768px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
  }
`;

export const ModalIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 24 24',
  width: props.fontSizeEnabled ? 18 * percentageSize : 18,
  fill: '#fff'
}))``;

export const BackIcon = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  viewBox: '0 0 447.243 447.243',
  width: props.fontSizeEnabled ? 20 * percentageSize : 20,
  fill: 'white'
}))`
  cursor: pointer;
  width: 16px;
  margin-right: 10px;
`;

export const InfoCercaListWrapper = styled.div`
  margin-top: 15px;
  color: white;
`;
export const InfoCercaElementWrapper = styled.div`
  display: flex;
  margin-bottom: 5px;
  gap: 5px;
`;
export const InfoCercaElementTitle = styled.div`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
  font-weight: bold;
`;
export const InfoCercaElementPlaceHolder = styled.div`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
`;

export const InfoCercaText = styled.div`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
`;
export const InfoCercaSeparetor = styled.div`
  margin-top: 25px;
`;

export const InfoCercaLocationWrapper = styled.div`
  /* margin-left: 25px; */
`;
